module.exports = __webpack_public_path__ + "static/media/new.461a4f94.svg";